<template>
	<div class="footBox">
		<div class="footCont">
			<div class="conBox1">
				<div class="conpanyName">
					<div class="nameTextc">深圳摩米贝尔科技有限公司</div>
				</div>
				<div class="conpanyName">
<!-- 					<div @click="routerGoDis" class="c-item" style="cursor: pointer;">纠纷处理 &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</div>
					<div @click="routerGomy" class="c-item" style="cursor: pointer;">自审制度 &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;        </div> -->
					<div class="c-item">违法和不良信息举报邮箱：allen.lhl@momibell.com &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;    </div>
					<div class="c-item">联系电话：159 8989 7729</div>
				</div>
				<div class="conpanyName">
					<div class="c-item">公司地址：深圳市宝安区愉盛综合大厦4栋719</div>
				</div>
				<div class="conpanyName">
					<div class="c-item"><a href="http://beian.miit.gov.cn" target="_blank">粤ICP备17022663号-1</a> Copyright © 2014-2026         </div>
				</div>
				
			</div>
			<div class="conBox2">
				<img class="conBox2-pic" src="../assets/images/logo.png" />
				<div class="conBoxTxt">摩米贝尔</div>
				<div class="conBoxTxt">MOMI智慧自助空间，我用它</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "footerAddress",
	data (){
		return{
			
		}
	},
	methods:{
		routerGoDis(){
			this.$router.push("/dispute")
		},
		
		routerGomy(){
			this.$router.push("/examine")
		}
	}
}
</script>

<style>
	@media screen and (max-width: 1200px) {
		.footBox{
			display: none;
			width: 100%;
			height: auto;
			background-color: #272b2e;
		}
	}
	@media screen and (min-width: 1200px) {
		.footBox{
			display: block;
			width: 100%;
			height: auto;
			background-color: #272b2e;
		}
		.footCont{
			font-size: 12px;
			padding: 27px 0;
			color: #969799;
			width: 1200px;
			margin: 0 auto;
			display: flex;
			align-items: center;
		}
	}
	
	
	.conBox2-pic{
		height: 56px;
		width: 56px;
		border-radius: 50%;
	}
	.c-item{
		display: inline-block;
	}
	a:LINK {
	     color: #969799;
	     text-decoration: none;
	} 
	a:VISITED {
	    color: #969799;
	    text-decoration: none;
	}   
	a:HOVER {
	    background-color: #ff6a00;
	    text-decoration: none;
	}
	
	.conBox1{
		flex: 1;
	}
	.conBox2{
		width: 228px;
		border-left: 1px #3d4043 solid;
	}
	.conpanyName{
		margin-bottom: 8px;
		height: 18px;
		line-height: 18px;
		text-align: left;
	}
	.nameTextc{
		padding-right: 24px;
		display: inline-block;
	}
	.nameNet{
		display: inline-block;
	}
	
</style>
